import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reservation-tab',
  templateUrl: './reservation-tab.component.html',
  styleUrls: ['./reservation-tab.component.scss']
})
export class ReservationTabComponent implements OnInit {
  
  public id;

  constructor(
    public menu: MenuService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
  }

}
